import "./navbar.scss";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link } from "react-router-dom";
import { useContext, useState, useRef, useEffect } from "react";
import { DarkModeContext } from "../../context/darkModeContext";
import { AuthContext } from "../../context/authContext";
import { useNavigate } from 'react-router-dom';
import Credits from "../credits/Credits";

const Navbar = ({setAuth}) => {
  // get Tenant name from the environment variable
  const tenantName = process.env.REACT_APP_TENANT_NAME;
  const { toggle, darkMode } = useContext(DarkModeContext);
  const { currentUser } = useContext(AuthContext);
  // State to manage dropdown visibility
  const [dropdownOpen, setDropdownOpen] = useState(false);
  
  // Ref for detecting clicks outside the dropdown
  const dropdownRef = useRef(null);
 
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setAuth(false);
    navigate('/login');
  };

  // Close dropdown when clicked outside
  useEffect(() => {
    const closeDropdown = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", closeDropdown);
    return () => document.removeEventListener("mousedown", closeDropdown);
  }, []);

  // Toggle dropdown visibility
  const handleToggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  }

  return (
    <div className="navbar">
      <div className="left">
        <Link to="/" style={{ textDecoration: "none" }}>
          <span>Pinpoint - {tenantName}</span>
        </Link>
        <HomeOutlinedIcon />
        {darkMode ? (
          <WbSunnyOutlinedIcon onClick={toggle} />
        ) : (
          <DarkModeOutlinedIcon onClick={toggle} />
        )}
        <GridViewOutlinedIcon />
        <div className="search">
          <SearchOutlinedIcon />
          <input type="text" placeholder="Search..." />
        </div>
      </div>
      <div className="right">
        <Credits/>
        <PersonOutlinedIcon />
        <EmailOutlinedIcon />
        <NotificationsOutlinedIcon />
        <div className="user"  onClick={handleToggleDropdown}>
          <img
            src={currentUser.profilePic}
            alt=""
          />
         <span className="username">
            {currentUser.name}
          </span>
          {/* Dropdown Menu */}
          {dropdownOpen && (
            <div className="dropdownMenu">
              <hr />
              <Link to={`/profile/${currentUser.id}`} className="dropdownItem" onClick={() => setDropdownOpen(false)}>
                <PersonOutlinedIcon className="dropdownIcon" />
                Profile
              </Link>
              <Link to="/settings" className="dropdownItem" onClick={() => setDropdownOpen(false)}>
                <SettingsOutlinedIcon className="dropdownIcon" />
                Settings
              </Link>
              <div className="dropdownItem" onClick={handleLogout}>
                <LogoutIcon className="dropdownIcon" />
                Logout
              </div>
            </div>
          )}
        </div>
        </div>
    </div>
  );
};

export default Navbar;
